import axiosClient from "../../network";

export default class fifaService {
  /**
   * Fetch FIFA matches for the lobby banner
   * @param {number} limit 
   * @param {number} page 
   */
  static getFifaMatches(limit = 10, page = 1) {
    return axiosClient
      .get(`/sb/fifa-banner?limit=${limit}&page=${page}`)
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }
}